module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "para_1"
  }, [_vm._v("Many individuals helped make this book of vintage postcards possible. Some pointed me in the direction I needed to go in order to do my own research, while others sent me quotes from books I did not have at my disposal.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Phyllis Ciano, museum coordinator at Banner House Museum in Banner Elk, North Carolina, graciously sent me background information about the Pinnacle Inn. The details she sent me from "), _c('i', [_vm._v("Banner Elk, North Carolina: A Guide to the Town and Its Historic Places")]), _vm._v(", compiled by the Greater Banner Elk Heritage Foundation and financed through the Banner Elk Tourism and Development Authority, enabled me to include my two Pinnacle Inn postcards in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bonnie Hillyer of Harrisburg, North Carolina, helped me find the information I needed in order to write the history of some of the buildings at Lake Junaluska Conference and Retreat Center.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Shannon Ames, director of community and stockholder relations for Brookfield Renewable Energy Group in Marlborough, Massachusetts, verified that a postcard labeled as “Topoco Dam” was actually Cheoah Dam. Without her assistance, I would have been on shaky ground to include that postcard in the book.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I owe my sister, Marie Morrison of Harrisburg, North Carolina, a debt of gratitude for her moral support, proofreading, and patience as I worked on this book. I dominated our computer for weeks on end, and she never once complained about that or the stacks of postcards all over the house. All images appear courtesy of the author, and all images were originally in color except where noted.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 75
// module chunks = 0